import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import ClearIcon from '@material-ui/icons/Clear'
import IconButton from '@material-ui/core/IconButton'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import TariffsTable from './tariffsTable'
import TariffsDialog from './tariffsDialog'

import { validateAuth } from '../services/userService'
import ApiService from '../services/dataService'
import getString from '../config/strings'
import { showAlert } from './alert'

const styles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
  margin: {
    margin: theme.spacing(1),
  },
  textField: {
    maxWidth: 300,
    flexBasis: '100%'
  },
})

class TariffPage extends PureComponent {
  constructor (props, context, updater) {
    super(props, context, updater)
    this.state = {
      tariffs: [],
      dialogOpen: false,
      filter: ''
    }
  }

  componentDidMount () {
    let self = this

    validateAuth(this.props.auth).then(function (auth) {
      if (auth !== null) {
        ApiService.getAllTariffs(auth['access_token']).then(function (data) {
          self.setState({tariffs: data})

          if (auth['access_token'] !== self.props.auth['access_token']) {
            self.props.parent.setLogin(auth)
          }
        }).catch(function (error) {
          console.error('ERROR', 'tariff page mount', error)
          showAlert(getString(error.message), getString('ERROR_HEADLINE'))
        })
      } else {
        self.props.parent.setLogin(null)
      }
    })
  }

  filteredTariffs() {
    const filter = this.state.filter
    if ( filter )
      return this.state.tariffs.filter(function(tariff){return tariff.name.match(new RegExp(filter, 'gi')) || tariff.description.match(new RegExp(filter, 'gi'))})
    else
      return this.state.tariffs
  }

  openDialog (index) {
    const tariffs = this.filteredTariffs()
    let record = (index !== -1 && this.state.tariffs[index])
      ? Object.assign({}, tariffs[index], {visible_from: new Date(tariffs[index]['visible_from'])})
      : {name: '', description: '', visible_from: new Date()}

    this.setState({dialogOpen: true, actRecord: record, actIndex: index})
  }

  closeDialog () {
    this.setState({dialogOpen: false})
  }

  async saveDialog (record) {
    let self = this
    if (record.name && record.description) {
      try {
        let auth = await validateAuth(self.props.auth)
        if (auth !== null) {
          if (this.state.actIndex === -1) {
            let data = await ApiService.saveTariff(record, auth['access_token'])
            let tariffs = self.state.tariffs.slice()
            tariffs.push(data)
            self.setState({tariffs: tariffs, dialogOpen: false})
          } else {
            let data = await ApiService.updateTariff(record, auth['access_token'])
            let tariffs = self.state.tariffs.slice()
            for (let i = 0, l = tariffs.length; i < l; i++) {
              if (tariffs[i].id === record.id) {
                tariffs[i] = data
                break
              }
            }
            self.setState({tariffs: tariffs, dialogOpen: false})
          }

          // save renewed auth in parent
          if (auth['access_token'] !== self.props.auth['access_token']) {
            self.props.parent.setLogin(auth)
          }
        } else {
          // logout renew fails
          self.setState({dialogOpen: false})
          self.props.parent.setLogin(null)
        }
      } catch (error) {
        console.error('ERROR', 'save tariff', error)
        showAlert(getString(error.message), getString('ERROR_HEADLINE'))
      }
    } else {
      console.error('ERROR', 'save tariff', 'invalid data')
      showAlert(getString('NO_INPUT'), getString('ERROR_HEADLINE'))
    }
  }

  async deleteRecord (index) {
    let self = this
    const filteredTariffs = self.filteredTariffs()
    let record = (filteredTariffs[index]) ? Object.assign({}, filteredTariffs[index]) : null
    if (record) {
      try {
        let auth = await validateAuth(self.props.auth)
        if (auth !== null) {
          await ApiService.deleteTariff(record.id, auth['access_token'])
          let tariffs = self.state.tariffs.slice()
          for (let i = 0, l = tariffs.length; i < l; i++) {
            if (tariffs[i].id === record.id) {
              tariffs.splice(i, 1)
              break
            }
          }
          self.setState({tariffs: tariffs})

          // save renewed auth in parent
          if (auth['access_token'] !== self.props.auth['access_token']) {
            self.props.parent.setLogin(auth)
          }
        } else {
          // logout renew fails
          self.props.parent.setLogin(null)
        }
      } catch (error) {
        console.error('ERROR', 'delete tariff', error)
        showAlert(getString(error.message), getString('ERROR_HEADLINE'))
      }
    }
  }

  handleFilterChange (event) {
    this.setState({filter: event.target.value})
  }

  render () {
    const {classes} = this.props
    let tariffs = this.filteredTariffs()

    return (
      <Grid container spacing={3} style={{flexGrow: 1, marginTop: 12}}>

        <Grid item container xs={12} sm={6} justify='center' alignItems='center'>
          <div>
            <Button variant="contained" color="primary" onClick={() => {this.openDialog(-1)}}>
              <AddIcon className={classes.leftIcon}/>
              {getString('ADD_TARIFF')}
            </Button>
          </div>
        </Grid>

        <Grid item container xs={12} sm={6} justify='center' alignItems='center'>
          <FormControl className={classNames(classes.margin, classes.textField)}>
            <InputLabel htmlFor="filterField">{getString('TARIFF_LABEL_FILTER')}</InputLabel>
            <Input
              id="filterField"
              type='text'
              value={this.state.filter}
              onChange={(event) => {this.handleFilterChange(event)}}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={getString('TARIFF_DELETE_FILTER')}
                    onClick={() => {this.setState({'filter': ''})}}
                  >
                    <ClearIcon/>
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TariffsTable tariffs={tariffs} editFunc={(index) => {this.openDialog(index)}}
                        deleteFunc={(index) => {this.deleteRecord(index)}} isFiltered={this.state.filter != ''}/>
          {this.state.dialogOpen &&
          <TariffsDialog title={getString(this.state.actIndex === -1 ? 'ADD_TARIFF' : 'EDIT_TARIFF')}
                         action={getString(this.state.actIndex === -1 ? 'SAVE_TARIFF' : 'UPDATE_TARIFF')}
                         closeFunc={() => {this.closeDialog()}}
                         saveFunc={(record) => {this.saveDialog(record)}}
                         record={this.state.actRecord}/>}
        </Grid>

      </Grid>
    )
  }
}

TariffPage.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object,
  parent: PropTypes.object.isRequired
}

export default withStyles(styles)(TariffPage)
